import { useState } from 'react';
import { Box, List, ListSubheader, ListItemButton, ListItemText, Collapse } from '@mui/material';
import { ExpandLess as ExpandLessIcon, ExpandMore as ExpandMoreIcon } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { CertMDRProduct } from '../types';

type ProductListItem = CertMDRProduct & {
  open?: boolean;
};

type ProductListProps = {
  products: CertMDRProduct[];
};

const Products = ({ products }: ProductListProps) => {
  const { t } = useTranslation();
  const [productsData, setProductsData] = useState<ProductListItem[]>(products);

  const handleClick = (id: string) => {
    const newList = productsData.map((prod) => {
      if (id === prod.id) {
        const tmp = {
          ...prod,
          open: !prod.open,
        };
        return tmp;
      }
      return prod;
    });

    setProductsData(newList);
  };

  const renderExpandButton = (product: ProductListItem) => {
    if (product.open) {
      return <ExpandLessIcon />;
    }
    if (!product.open) {
      return <ExpandMoreIcon />;
    }
    return null;
  };

  return (
    <List
      sx={{ mt: 5, width: '100%', borderRadius: '4px', boxShadow: 1 }}
      component="div"
      aria-labelledby="certmdproduct-list"
    >
      {productsData.map((product) => (
        <Box component="div" key={product.id}>
          <ListItemButton onClick={() => handleClick(product.id)}>
            <ListItemText
              primaryTypographyProps={{ fontSize: '1.25rem' }}
              secondaryTypographyProps={{ fontSize: '1rem' }}
              primary={product.product ?? 'N/A'}
            />
            {renderExpandButton(product)}
          </ListItemButton>

          {productsData?.length > 0 ? (
            <Collapse in={product.open} timeout="auto" unmountOnExit>
              <List component="div" dense disablePadding>
                <ListItemButton sx={{ pl: 4 }}>
                  <ListItemText
                    primaryTypographyProps={{ fontSize: '1.25rem' }}
                    secondaryTypographyProps={{ fontSize: '1rem' }}
                    primary={product.emdnCode ?? 'N/A'}
                    secondary={`Model: ${product.model} `}
                  />
                </ListItemButton>
              </List>
            </Collapse>
          ) : null}
        </Box>
      ))}
    </List>
  );
};

export default Products;
